import { memo } from "react";
import type { FunctionComponent, ReactNode } from "react";

import { Portal } from "~/components/common/portal";
import { HeaderArticleSpeechContainerElementID } from "~/components/header/consts";

export type Props = {
  children?: ReactNode;
};

const Component: FunctionComponent<Props> = ({ children }) => (
  <Portal selector={`#${HeaderArticleSpeechContainerElementID}`}>{children}</Portal>
);
Component.displayName = "HeaderArticleSpeech";

export const HeaderArticleSpeech = memo(Component);
